module.exports = __webpack_public_path__ + "img/module2_icon4.1c5c22f5.png";